import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Button from "../../../components/common/Button";
import Form from "../../../components/common/Form";
import Input from "../../../components/common/Input";
import Logo from "../../../components/logo/Logo";
import { validateEmail } from "../../../utils";
import { OnForgotPassword } from "./queries";
import skillOffer from "../../../svg/skill-offer.svg";
import "./index.scss";
import LightButton from "../../../components/common/Light_button";

function ForgotPassword() {
  const [email, setEmail] = useState();
  const [disabled, setDisabled] = useState(true);

  const handleChange = (e) => {
    setEmail(e.target.value);
  };
  const sucessHandler = (forgotSucess) => {
    // toast.success(forgotSucess?.data?.message);
  };
  const { mutate: forgotPassword } = OnForgotPassword(sucessHandler);

  useEffect(() => {
    setDisabled(!validateEmail(email));
  }, [email]);

  const handleSubmit = (e) => {
    e.preventDefault()
    const data = { email: email }
    forgotPassword(data)
  }

  return (
    <div className="container-flex forgot-page">
      <div className="row h-100">
        <div className="col-lg-4 col-xl-4 d-none d-lg-block left-base position-relative left-base">
          <div>
            <img src={skillOffer} alt="skill offer" className="p-3 mt-5 w-90" />
            <div className="text-start text-white w-90 m-auto py-2 px-3">
              <p>lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. labore eta.
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-8 col-xl-8 col-md-12 col-sm-12 m-auto">
          <div className="frame w-75 m-auto">
            <Logo />
            <h4>Reset Password</h4>
            <p className="sub_title">
              We are almost there! Choose a password that is unique to you.
            </p>
            <Form onSubmit={handleSubmit}>
              <Input
                name="email"
                handleChange={handleChange}
                labelClass={email ? "" : "hidden"}
                type="email"
                preIconClass="fa fa-envelope"
                showLabel
                label="Email ID"
                placeholder="Email ID"
                value={email}
                className={
                  email
                    ? "form-control active-input with_icon"
                    : "form-control grey-input with_icon"
                }
              />
              <div className="mb-5 mt-5">
                <Link to="/">
                  <LightButton title="Cancel" />
                </Link>
                <Button type="submit" title="Submit" disabled={disabled} />
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ForgotPassword;
